import API from '../api';
import { toMoment } from './normalizers';
import round from './round';
import configEntidad from './configEntidad';

const fechaApartirInicioPeriodo = () => {
  const config = configEntidad();
  if (config) {
    return config?.fecha_recargo_apartir_inicio_periodo || false;
  }
  return false;
};

const diffDates = (date1, date2, separator = '-') => {
  const d1 = date1.split(separator);
  const d2 = date2.split(separator);
  const date1Obj = new Date(d1[0], d1[1] - 1, d1[2]);
  const date2Obj = new Date(d2[0], d2[1] - 1, d2[2]);

  const apartirDePeriodo = fechaApartirInicioPeriodo();

  return {
    years: date2Obj.getFullYear() - date1Obj.getFullYear(),
    months: apartirDePeriodo
      ? (date2Obj.getMonth() - date1Obj.getMonth()) + 1 : date2Obj.getMonth() - date1Obj.getMonth(),
    days: apartirDePeriodo ? 0 : (date2Obj.getDate() - date1Obj.getDate()),
  };
};

// Obtenemos el factor de vencimiento
const getFactorDeVencimiento = ({ tipo_de_recargo, fecha_de_vencimiento, now }) => {
  let factor_de_vencimiento = 0;
  const diferencia_de_fechas = diffDates(fecha_de_vencimiento, now.format('YYYY-MM-DD'));
  const diferencia_en_dias = diffDates(fecha_de_vencimiento, now.format('YYYY-MM-DD')).days;

  let total_meses = 0;
  switch (tipo_de_recargo.periodo_id) {
    case 2: // Diario
      factor_de_vencimiento = diferencia_en_dias;
      break;
    case 3: // Semanal
      factor_de_vencimiento = Math.floor(
        diferencia_en_dias / 7,
      ) + (diferencia_en_dias % 7 > 0 ? 1 : 0);
      break;
    case 4: // Quincenal
      factor_de_vencimiento = Math.floor(
        diferencia_en_dias / 15,
      ) + (diferencia_en_dias % 15 > 0 ? 1 : 0);
      break;
    case 5: // Mensual
      factor_de_vencimiento = diferencia_de_fechas.years * 12 + diferencia_de_fechas.months
        + (diferencia_de_fechas.days > 0 ? 1 : 0);
      break;
    case 6: // Bimestral
      total_meses = diferencia_de_fechas.years * 12 + diferencia_de_fechas.months;
      factor_de_vencimiento = Math.floor(total_meses / 2) + (total_meses % 2 > 0 ? 1 : 0);
      break;
    case 7: // Trimestral
      total_meses = diferencia_de_fechas.years * 12 + diferencia_de_fechas.months;
      factor_de_vencimiento = Math.floor(total_meses / 3) + (total_meses % 3 > 0 ? 1 : 0);
      break;
    case 8: // Cuatrimestral
      total_meses = diferencia_de_fechas.years * 12 + diferencia_de_fechas.months;
      factor_de_vencimiento = Math.floor(total_meses / 4) + (total_meses % 4 > 0 ? 1 : 0);
      break;
    case 9: // Semestral
      total_meses = diferencia_de_fechas.years * 12 + diferencia_de_fechas.months;
      factor_de_vencimiento = Math.floor(total_meses / 6) + (total_meses % 6 > 0 ? 1 : 0);
      break;
    case 10: // Anual
      // eslint-disable-next-line max-len
      factor_de_vencimiento = diferencia_de_fechas.years + (diferencia_de_fechas.months > 0 ? 1 : 0);
      break;
    default:
      break;
  }
  return factor_de_vencimiento;
};

export const getINPC = async (periodo, mes) => {
  try {
    const data = await API.get('configuracion/inpc-public', {
      params: {
        periodo,
        mes,
      },
    });
    return data.data.results;
  } catch (error) {
    return null;
  }
};

export const actualizacionTotal = async ({
  importe_cargo,
  tipo_de_cargo,
  INPC,
}) => {
  try {
    let output = 0.00;

    if (tipo_de_cargo?.fecha_de_vencimiento === null) return output;

    const factor_inpc = INPC?.factor_de_actualizacion_sat;

    if (factor_inpc > 1.00) {
      const [importe_rounded] = round(importe_cargo * 1);
      const fourDigits = factor_inpc.toFixed(4);

      output = (importe_rounded * fourDigits) - importe_rounded;
      return round(output)[0];
    }

    return parseInt(output, 10);
  } catch (error) {
    return null;
  }
};

export const recargosTotal = async ({
  tipo_de_cargo,
  importe_cargo,
  fecha_de_vencimiento,
  now,
}) => {
  try {
    let output = 0.00;
    let factor_de_vencimiento = 0;

    if (fecha_de_vencimiento === null) return output;

    const tipo_de_recargo = {
      periodo_id: tipo_de_cargo?.periodo?.id,
    };

    /* Se obtiene el factor de vencimiento */
    factor_de_vencimiento = getFactorDeVencimiento({
      tipo_de_recargo,
      fecha_de_vencimiento,
      now: toMoment(now),
    });

    /* Verifica si la entidad tiene configurado el recargo a partir del inicio del periodo,
      si es así, se incrementa en 1 el factor de vencimiento
      si no se toma el factor de vencimiento tal cual
    */
    // DEBE DAR 9 DE ABRIL A DICIEMBRE
    // const inicioPeriodo = fechaApartirInicioPeriodo();
    // if (inicioPeriodo) {
    //   factor_de_vencimiento += 1;
    // }

    /* Si el factor de vencimiento es mayor a 60, se toma el 88.2% del importe_cargo,
    de lo contrario se toma el 1.47% del factor de vencimiento */
    const porcentaje = factor_de_vencimiento > 60 ? 0.882 : (factor_de_vencimiento * 0.0147);

    if (factor_de_vencimiento > 0) {
      const parseValue = parseFloat(importe_cargo);
      const [importe_rounded] = round(parseValue);
      output = (importe_rounded) * (porcentaje);
    }

    return round(output)[0];
  } catch (error) {
    return null;
  }
};
